import React from "react";
import { observer } from "mobx-react-lite";

import { StatisticsGroups } from "@data-types/offer/event/EventViewStoreEnums";
import { useOfferContext } from "@state/hooks/offer/useOfferContext";
import { OfferStore } from "@state/context/offer/OfferContext";
import { StreakStatsBody } from "./StreakStatsBody";

export const StreaksStatistics = observer(function StreaksStatistics(props: {
	isSettingsDrawerOpen: boolean;
	onClose: (value: boolean) => void;
}) {
	const store = useOfferContext<OfferStore.EventViewStore>();

	if (store?.displayStatisticsGroup === StatisticsGroups.StreakStats) {
		return (
			<StreakStatsBody
				store={store}
				isSettingsDrawerOpen={props.isSettingsDrawerOpen}
				onClose={props.onClose}
			/>
		);
	}

	return null;
});
